import AxiosConfig from '@/config/axios-config'

export const ResetPasswordAPI = {
  downloadLinksResetSenhasUsuariosFrios () {
    return AxiosConfig.secureJalekoAPI().get('/admin/links-reset-senhas/usuarios-frios')
  }
}

export default ResetPasswordAPI
